﻿import Swiper, { Pagination, Navigation } from 'swiper';

Swiper.use([Pagination, Navigation]);

const swiperNavNextSelector = '.swiper-button-next';
const swiperNavPrevSelector = '.swiper-button-prev';
const swiperPaginationSelector = '.swiper-pagination';

const swiperConfig = {
    slidesPerView: 'auto',
    spaceBetween: 32
};

document.addEventListener('DOMContentLoaded', () => {
    const $logoWidgets = document.querySelectorAll('.widget-logo');

    $logoWidgets.forEach($logoWidget => {
        let $next = $logoWidget.querySelector(swiperNavNextSelector);
        let $prev = $logoWidget.querySelector(swiperNavPrevSelector);
        let $pagination = $logoWidget.querySelector(swiperPaginationSelector);
        let $slider = $logoWidget.querySelector('.widget-logo-slider');

        new Swiper($slider, {
            ...swiperConfig,
            navigation: {
                nextEl: $next,
                prevEl: $prev,
            },
            pagination: {
                el: $pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });

    const $reviewWidgets = document.querySelectorAll('.widget-review');

    $reviewWidgets.forEach($reviewWidget => {
        let $next = $reviewWidget.querySelector(swiperNavNextSelector);
        let $prev = $reviewWidget.querySelector(swiperNavPrevSelector);
        let $pagination = $reviewWidget.querySelector(swiperPaginationSelector);
        let $slider = $reviewWidget.querySelector('.widget-review-slider');

        new Swiper($slider, {
            ...swiperConfig,
            slidesPerView: 1.2,
            breakpoints: {
                768: {
                    slidesPerView: 1.7
                },
                1024: {
                    slidesPerView: 2.1
                },
                1407: {
                    slidesPerView: 2.5
                },
            },
            navigation: {
                nextEl: $next,
                prevEl: $prev,
            },
            pagination: {
                el: $pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });
});
